const convertTime = (number: string) => {
  let parsedHours = number.substr(0, 2);
  const minutes = number.substr(2, 2);

  let formattedTime = '';
  let meridiem = 'AM';
  let _hours: number = +parsedHours;

  if (+parsedHours >= 12) {
    meridiem = 'PM';
    if (+parsedHours > 12) {
      _hours -= 12;
    }
  }

  if (parsedHours === '00') {
    parsedHours = '12';
  }

  if (parsedHours[0] === '0') {
    parsedHours = parsedHours.slice(1);
  }

  formattedTime = `${_hours}:${minutes} ${meridiem}`;

  return formattedTime;
};

export default convertTime;
